import { auth, googleAuthProvider, db } from "../../firebase/firebase";
import moment from 'moment';

const createUserWithEmailPasswordRequest = async (payload) => {
  const { email, password } = payload;
  try {
    const authUser = await auth.createUserWithEmailAndPassword(email, password)
    await db.ref().child('users').child(authUser.user.uid)
    .set({ ...payload, id: authUser.user.uid, dateOfRegister: moment().format('MM/DD/YYYY') });
    return authUser
  } catch (error) {
    return error;
  }
}

const signInUserWithEmailPasswordRequest = async ({email, password}) => {
  const user = await  auth.signInWithEmailAndPassword(email, password);
  return user;
}

const signOutRequest = async () =>
  await  auth.signOut()
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithGoogleRequest = async () =>
  await  auth.signInWithPopup(googleAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

const getUserFromRDB = async (uid) => {
  let userData;
  await db.ref(`users/${uid}`).once('value', (data) => {
    userData = data.val();
  }, (e) => console.log(e));
  return userData;
}

export {
  createUserWithEmailPasswordRequest,
  signInUserWithEmailPasswordRequest,
  signOutRequest,
  signInUserWithGoogleRequest,
  getUserFromRDB,
}